import {object, string} from 'yup';

import {isNil} from 'ramda';

import {ScopeValues} from '@dms/api/shared';

export const evaluateServiceCaseType = (scopes: string[], evaluatorParams: ScopeValues) => {
  const {serviceCaseType} = validateServiceCaseEvaluatorParams(evaluatorParams);

  if (isNil(serviceCaseType)) {
    return false;
  }

  return scopes.includes(serviceCaseType);
};

// export only for testing purposes
export const validateServiceCaseEvaluatorParams = (evaluatorParams: ScopeValues | null) =>
  serviceCaseParamsSchema.validateSync(evaluatorParams);

const serviceCaseParamsSchema = object({
  serviceCaseType: string().nullable(),
});
